window.addEventListener('load', () => {
  Utils.setDatepicker();
  Utils.setSelect2();
});

/**
 * 공통함수
 */
const Utils = (function () {
  let global = {};

  init();

  /**
   * Initialize (Only Once)
   */
  function init() {
    setHeaderEvent();
    setTooltip();
    setTableCheckbox();
    setMyFarmImageAnimation();
    setFadeInImageAnimation();
  }
  /**
   * Set Header Tab Event For Accessibility
   */
  function setHeaderEvent() {
    const $btnMobileMenu = $('.navbar-nav.mobile a');
    const $mobileMenu = $('.navbar.mobile');
    const $navItem = $('.layout-header .navbar-nav .nav-item');
    const $navLink = $('.navbar-brand, .layout-header .navbar-nav li > a');
  
    // #region mobile menu event
    $btnMobileMenu.on('click', () => {
      $('.layout-header').append('<div class="header-backdrop modal-backdrop fade"></div>');
      $mobileMenu.addClass('active');
      $mobileMenu.addClass('visible');
      setTimeout(() => {
        $('.header-backdrop').addClass('show');
      }, 100);
    });
    $(document).on('click', '.header-backdrop, .btn-navbar-close', () => {
      $('.header-backdrop').removeClass('show');
      $mobileMenu.removeClass('active');
      setTimeout(() => {
        $('.header-backdrop').remove();
        $mobileMenu.removeClass('visible');
      }, 300);
    });
    // #endregion mobile menu event
    // #region tab event
    $navItem.on('focusin', function () {
      removeMenuActive();
      $(this).addClass('active');
    });
    $navItem.on('click', function () {
      $navItem.removeClass('active-only');
      $(this).addClass('active-only');
      $(this).removeClass('active');
    });
    $navLink.on('focusin', function () {
      removeMenuActive();
    });
    $(document).on('mousedown', function () {
      removeMenuActive();
    });
    $('.layout-main, .layout-footer').on('focusin', function () {
      removeMenuActive();
    });
    function removeMenuActive() {
      $('.layout-header .navbar-nav .nav-item').removeClass('active');
    }
    // #endregion tab event
  }
  /**
     * Set Tooltip
     */
  function setTooltip() {
    $(document).on('mouseenter', '[data-toggle="tooltip"]', function () {
      $(this).tooltip({
        content: function () {
          return $(this).prop('title');
        },
      });
      $(this).tooltip('open');
    });
  };
  /**
   * Set Table Checkbox
   */
  function setTableCheckbox() {
    $(document).on('change', '.ta-table-wrap input.all', (e) => {
      let $tableWrap = $(e.target).parents('.ta-table-wrap');
      let $eachCheckboxList = $tableWrap.find('input.each');
      $eachCheckboxList.prop('checked', $(e.target).prop('checked'));
    });
    $(document).on('change', '.ta-table-wrap input.each', (e) => {
      let $tableWrap = $(e.target).parents('.ta-table-wrap');
      let $allCheckbox = $tableWrap.find('input.all');
      let $eachLength = $tableWrap.find('input.each').length;
      let $eachCheckedLength = $tableWrap.find('input.each:checked').length;
      if ($eachLength == $eachCheckedLength) {
        $allCheckbox.prop('checked', true);
      } else {
        $allCheckbox.prop('checked', false);
      }
    });
  }
  /**
   * Set My Farm Image Scroll Animation (tilt on view)
   */
  function setMyFarmImageAnimation() {
    const images = document.querySelectorAll('.my-farm-image, .add-farm-image');
    if (!images.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const img = entry.target;
          if (entry.isIntersecting) {
            img.classList.remove('is-visible');
            img.offsetHeight; // reflow
            img.classList.add('is-visible');
          } else {
            img.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0.3, rootMargin: '0px' }
    );
    images.forEach((img) => observer.observe(img));
  }
  /**
   * Set Fade-in Image Animation (info section images)
   */
  function setFadeInImageAnimation() {
    const elements = document.querySelectorAll('.fade-in-image');
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;
          if (entry.isIntersecting) {
            el.classList.remove('is-visible');
            el.offsetHeight;
            el.classList.add('is-visible');
          } else {
            el.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px' }
    );
    elements.forEach((el) => observer.observe(el));
  }

  // #region Event
  function onSelect2OpenEvent() {
    // Only Dropdown
    if($(this).hasClass('dropdown')) {
      $('.select2-dropdown').closest('.select2-container').addClass('dropdown');
    }
  }
  function onSelect2SelectEvent() {
    // Multiple Select2 Set Unit
    if($(this).attr('multiple') == 'multiple') {
      let $options = $('.select2-selection--multiple .select2-selection__choice');
      if($(this).data('unit')) {
        $options.attr('data-unit', $(this).data('unit'));
      } else {
        $options.attr('data-unit', '개 항목');
      }
    }
  }
  // #endregion Event 

  return {
    /**
     * Set Datepicker
     */
    setDatepicker() {
      let $datepicker = $('.datepicker');
      $datepicker.datepicker({ dateFormat: 'yy-mm-dd' });
      $datepicker.each(function () {
        if ($(this).hasClass('current')) {
          $(this).datepicker('setDate', 'today');
        }
        if ($(this).attr('data-min')) {
          if ($(this).attr('data-min') == 'current') {
            $(this).datepicker('option', 'minDate', 'today');
          } else {
            $(this).datepicker('option', 'minDate', $(this).attr('data-min'));
          }
        }
        if ($(this).attr('data-max')) {
          if ($(this).attr('data-max') == 'current') {
            $(this).datepicker('option', 'maxDate', 'today');
          } else {
            $(this).datepicker('option', 'maxDate', $(this).attr('data-max'));
          }
        }
      });
    },
    /**
     * Set Validation
     */
    setValidation() {
      let elements = document.querySelectorAll('input, textarea');
      for (let i = 0; i < elements.length; i++) {
        elements[i].oninvalid = function (e) {
          e.target.setCustomValidity(' ');
          if (!e.target.validity.valid) {
            elements[i].classList.add('is-invalid');
          }
        };
        elements[i].oninput = function (e) {
          e.target.setCustomValidity(' ');
        };
        if ($(elements[i]).attr('required')) {
          elements[i].focusout = () => {
            // elements[i].classList.remove('is-valid');
            elements[i].classList.remove('is-invalid');
            if (elements[i].value == null || elements[i].value == '') {
              elements[i].classList.add('is-invalid');
            } else {
              // elements[i].classList.add('is-valid');
            }
          };
        }
      }
    },
    /**
     * Set Select2
     */
    setSelect2() {
      const $select2List = $('select.select2');
      $select2List.each(function() {
        let options = {
          allowClear: true,
          language: {
            noResults: () => {
              if($(this).attr('data-search-placeholder')) {
                return $(this).attr('data-search-placeholder');
              } else {
                return '검색 결과가 없습니다.';
              }
            },
          },
        };
        $(this).select2(options);

        // mutilple select2 search input default is disabled
        setTimeout(() => {
          if($(this).attr('multiple') == 'multiple') {
            const $select2Search = $('.select2-selection--multiple .select2-search');
            $select2Search.find('input').attr('disabled', true);
          }
        }, 0);
      });

      $select2List.off('select2:open', onSelect2OpenEvent);
      $select2List.off('select2:select', onSelect2SelectEvent);
      $select2List.on('select2:open', onSelect2OpenEvent);
      $select2List.on('select2:select', onSelect2SelectEvent);
    },
    /**
     * Set Custom Select
     * if Change Select Call setCustomDropdownSelect(id);
     * @param {String} tagId
     */
    setCustomDropdownSelect(tagId = null) {
      const createCustomDropdownSelect = function (el) {
        let $originalSelect = $(el);
        let $originalOptgroupList = $originalSelect.find('optgroup');
        let $originalOptionList = $originalSelect.find('option');
        let placeholder = '선택';
        let isPlaceholder = false;
        if ($(el).parent().find('.custom-dropdown-select').length <= 0) {
          let newSelect = `
          <div class="dropdown custom-dropdown-select">
          <button class="btn dropdown-toggle" type="button" id="${$originalSelect.attr('id')}Dropdown" ${
            $originalSelect.attr('disabled') ? 'tabindex="-1"' : ''
          } data-toggle="dropdown" aria-expanded="false">
          ${placeholder}
          </button>
          <div class="dropdown-menu custom-dropdown-select" aria-labelledby="${$originalSelect.attr('id')}Dropdown">
          `;
          if ($originalOptgroupList.length > 0) {
            for (let i = 0; i < $originalOptgroupList.length; i++) {
              $originalOptionList = $originalOptgroupList.eq(i).find('option');
              newSelect += `
              <div class="dropdown-optgroup">
              <h6>${$originalOptgroupList[i].label}</h6>
              `;
              for (let j = 0; j < $originalOptionList.length; j++) {
                if ($originalOptionList[j].value == '') {
                  isPlaceholder = true;
                  placeholder = $originalOptionList[j].textContent;
                } else {
                  newSelect += `
                  <a href="javascript:void(0)"
                  class="dropdown-item ${$($originalOptionList[j]).prop('selected') ? 'active' : ''}"
                  data-value="${$originalOptionList[j].value}"
                  data-toggle="tooltip" data-placement="bottom"
                  title="${$originalOptionList[j].title}">
                  ${$originalOptionList[j].text}
                  </a>
                  `;
                }
              }
              newSelect += '</div>';
            }
          } else {
            for (let i = 0; i < $originalOptionList.length; i++) {
              if ($originalOptionList[i].value == '') {
                isPlaceholder = true;
                placeholder = $originalOptionList[i].textContent;
              } else {
                newSelect += `
                <a href="javascript:void(0)"
                class="dropdown-item ${$($originalOptionList[i]).prop('selected') ? 'active' : ''}"
                data-toggle="tooltip" data-placement="bottom"
                data-value="${$originalOptionList[i].value}"
                title="${$originalOptionList[i].title}">
                ${$originalOptionList[i].text}</a>
                `;
              }
            }
          }
          newSelect += `
          </div>
          </div>
          `;
          $originalSelect.after(newSelect);
          $originalSelect.next().find('.btn').text(placeholder);

          if ($(el).parent().find('a.dropdown-item.active').length > 0) {
            $('#' + $originalSelect.attr('id') + 'Dropdown').text($(el).parent().find('a.dropdown-item.active').text());
          } else {
            if (isPlaceholder) {
              $(el).parent().find('.custom-dropdown-select').addClass('dropdown-placeholder');
            }
          }
        }
      };
      if (tagId == null) {
        let $customSelect = $('.ta-custom-dropdown-select-wrap select:not(:disabled)');
        $(document).off('click', '.custom-dropdown-select .dropdown-item');
        $(document).on('click', '.custom-dropdown-select .dropdown-item', function () {
          let $this = $(this);
          setTimeout(function () {
            let $originalSelect = $this.parents('.ta-custom-dropdown-select-wrap').find('select');
            let $originalOptionList = $originalSelect.find('option:not([value=""]');
            let $index = $this.parents('.dropdown-menu').find('.dropdown-item').index($this);
            let $btn = $this.parents('.custom-dropdown-select').find('.btn');
            $originalOptionList.eq($index).prop('selected', true);
            $originalSelect.trigger('change');
            $btn.text($this.text());
            $btn.parent().removeClass('dropdown-placeholder');
            $this.parents('.dropdown-menu').find('.dropdown-item').removeClass('active');
            $this.addClass('active');
            $originalSelect.removeClass('is-invalid');
            $originalSelect.closest('div').parent().find('.invalid-feedback').remove();
          }, 0);
        });
        $customSelect.each((index, el) => {
          createCustomDropdownSelect(el);
        });
      } else {
        let $originalSelect = $(`#${tagId}`);
        $originalSelect.parent().find('.custom-dropdown-select').remove();
        createCustomDropdownSelect($(`#${tagId}`)[0]);
      }
    },
    /**
     * Get Global Variable
     */
    getGlobal() {
      return global;
    },
    /**
     * Get CSS Breakpoint
     */
    getBreakpoint() {
      let breakpoint = getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content');
      breakpoint = breakpoint.replaceAll('"', '');
      return breakpoint;
    },
    /**
     * Get input[type=file] detail
     * @param {Element} elmnt
     * @returns {Object}
     */
    getFileDetail(elmnt) {
      //파일 경로.
      let filePath = elmnt.value;
      //전체경로를 \ 나눔.
      let filePathSplit = filePath.split('\\');
      // 파일 전체명
      let originalFileName = filePathSplit[filePathSplit.length - 1];
      //파일확장자 앞 .의 index
      let lastDot = originalFileName.lastIndexOf('.');
      //파일명 : .으로 나눈 앞부분
      let fileName = originalFileName.substring(0, lastDot);
      //파일 확장자 : .으로 나눈 뒷부분
      let fileExt = originalFileName.substring(lastDot + 1, originalFileName.length).toLowerCase();
      //파일 크기
      let fileSize = filePath != '' ? elmnt.files[0].size : null;

      let object = {
        originalName: originalFileName,
        name: fileName,
        ext: fileExt,
        size: fileSize,
      };

      return object;
    },
    /**
     * Start Loading
     */
    startLoading() {
      let wrapElmnt = document.querySelector('.spinner-wrap');

      if (wrapElmnt) {
        wrapElmnt.dataset.task = Number(wrapElmnt.dataset.task) + 1;
      } else {
        wrapElmnt = document.createElement('div');
        wrapElmnt.classList.add('spinner-wrap');
        wrapElmnt.dataset.task = 1;
        let loadingElmnt = document.createElement('div');
        loadingElmnt.classList.add('spinner-border');
        let span = document.createElement('span');
        span.classList.add('sr-only');
        span.innerHTML = 'Loading...';
        loadingElmnt.appendChild(span);
        wrapElmnt.appendChild(loadingElmnt);

        let body = document.getElementsByTagName('body')[0];
        body.appendChild(wrapElmnt);
      }
    },
    /**
     * End Loading
     */
    endLoading() {
      setTimeout(function () {
        let wrapElmnt = document.querySelector('.spinner-wrap');

        if (wrapElmnt) {
          let taskCount = wrapElmnt.dataset.task;

          if (taskCount > 1) {
            wrapElmnt.dataset.task = Number(wrapElmnt.dataset.task) - 1;
          } else {
            wrapElmnt.style.opacity = 0;
            setTimeout(function () {
              wrapElmnt.remove();
            }, 300);
            let body = document.getElementsByTagName('body')[0];
          }
        }
      }, 300);
    },
    /**
     * Number to KRW format
     * ex) 1000000 -> 1,000,000
     * @param {Number} value
     * @returns {String}
     */
    numberFormatter(value) {
      if (value != '' && value != null && typeof value == 'number') {
        value = String(value)
          .replace(/[^\d]+/g, '')
          .replace(/(^0+)/, '')
          .replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
      } else {
        value = 0;
      }
      return value === '' ? 'NaN' : value;
    },
    /**
     * Byte to size
     * return ex) 5 GB
     * @param {Number} byte
     * @returns {String}
     */
    byteFormatter(byte) {
      let sizes = ['Byte', 'KB', 'MB', 'GB', 'TB'];
      if (byte == 0) return '0 Byte';
      let i = parseInt(Math.floor(Math.log(byte) / Math.log(1024)));
      return Math.round(byte / Math.pow(1024, i), 2) + ' ' + sizes[i];
    },
    /**
     * Set date format
     * @param {String} date
     * @returns {Object}
     */
    dateFormatter(date) {
      if ((date == '' || date == null) && typeof date == 'string') {
        return '';
      }
      const addZero = (num, digits) => {
        var zero = '';
        num = num.toString();

        if (num.length < digits) {
          for (var i = 0; i < digits - num.length; i++) {
            zero += '0';
          }
        }
        return zero + num;
      };
      // Safari Invalid Date 로 인한 replace
      date = date.substring(0, date.lastIndexOf('.')).replace(/-/g, '/').replace('T', ' ');
      let newDate = new Date(date);

      let yyyy = newDate.getFullYear();
      let mm = addZero(newDate.getMonth() + 1, 2);
      let m = newDate.getMonth() + 1;
      let dd = addZero(newDate.getDate(), 2);
      let d = newDate.getDate();

      let object = {
        slash: yyyy + '/' + mm + '/' + dd,
        dot: yyyy + '.' + mm + '.' + dd,
        dash: yyyy + '-' + mm + '-' + dd,
        word: yyyy + '년 ' + m + '월 ' + d + '일',
      };

      return object;
    },
  }
})();
